import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Hero from "../components/Hero"; 
import Pricing from "../components/Pricing";  
import Services from "../components/Services";
import Stats from "../components/Stats"; 
import WhyChooseUs from "../components/WhyChooseUs";
import { FaWhatsapp } from "react-icons/fa";

export default function Home() {
  const phoneNumber = "8438237072";
  const message = "Hi, I'm interested in your services";

  return (
    <div>
      <Hero />
      <Stats />
      <WhyChooseUs />
      <Services />   
      <Pricing /> 
      <Contact />
      <Footer/>

      {/* WhatsApp Floating Button - Minimal */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 z-50 group"
      >
        <div className="relative w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-2xl shadow-green-500/40 hover:shadow-green-500/60 hover:scale-110 transition-all duration-300">
          <FaWhatsapp className="text-white text-3xl" />
          
          {/* Pulse Effect */}
          <span className="absolute inset-0 border-2 border-green-500 rounded-full "></span>
          
          {/* Notification Dot */}
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
        </div>
      </a>
    </div>
  );
}